import { createFileRoute } from '@tanstack/react-router';
import { FAQPage } from '@/components/marketing/pages/FAQPage';

export const Route = createFileRoute('/_marketing/faq')({
  component: FAQPage,
});
